<template>
  <div>
    <v-dialog v-model="dialogUnPaid" persistent max-width="600px">
      <v-card>
        <v-card-title class="justify-center">
          ¿Quieres marcar la cuenta como impago?
        </v-card-title>

        <v-divider></v-divider>
        <br />

        <v-card-text class="text-center">
          <div>
            <v-btn
              @click="cancel"
              color="light"
              text
              style="
                margin-top: 5px;
                height: 50px;
                width: 50px;
                font-size: 50px;
              "
            >
              <font-awesome-icon
                icon="times-circle"
                :style="{ color: '#ea2222', fontSize: 50 }"
              />
            </v-btn>

            <v-btn
              @click="unPaidOrder"
              color="light"
              text
              style="
                margin-top: 5px;
                height: 50px;
                width: 50px;
                font-size: 50px;
              "
            >
              <font-awesome-icon
                icon="check-circle"
                :style="{ color: '#11bd11', fontSize: 50 }"
              />
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "order-unpaid-dialog",
  props: ["dialogUnPaid"],
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    unPaidOrder() {
      this.$emit("unPaidOrder");
    }
  }
};
</script>

<style scoped lang="scss"></style>
